var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { Badge } from './badge';
const StyledBadgeContainer = styled.div `
  position: relative;
  display: inline-block;
  [data-role='badge'] {
    top: ${(props) => getPos(props.placement).top};
    right: ${(props) => getPos(props.placement).right};
    bottom: ${(props) => getPos(props.placement).bottom};
    left: ${(props) => getPos(props.placement).left};
    transform: ${(props) => getPos(props.placement).transform};
    z-index: 1;
  }
`;
const StyledBadge = styled(Badge) `
  position: absolute;
`;
const getPos = (placement = 'top') => {
    const poses = {
        bottom: {
            bottom: '0px',
            right: '0px',
            transform: 'translate(50%, 50%)',
        },
        top: {
            top: '0px',
            right: '0px',
            transform: 'translate(50%, -50%)',
        },
    };
    return poses[placement];
};
export const BadgeContainer = (_a) => {
    var { placement = 'top', type = 'primary', children, className } = _a, props = __rest(_a, ["placement", "type", "children", "className"]);
    return (React.createElement(StyledBadgeContainer, { className: cx('badge', className), "data-role": "badge", placement: placement },
        React.createElement(StyledBadge, Object.assign({ type: type, count: props.count }, props)),
        children));
};
